import { Messages } from '@/constant';
export type BaseEntity = {
  id: string;
  createdAt: number;
};

export enum HttpStatus {
  OK = 200,
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  METHOD_NOT_ALLOWED = 405,
  INTERNAL_SERVER_ERROR = 500,
  SERVICE_UNAVAILABLE = 503,
  REQUEST_TIMEOUT = 504,
}
const externalErrorStr = Messages.M0023_E;

export const HttpStatusError = {
  BAD_REQUEST: externalErrorStr,
  UNAUTHORIZED: externalErrorStr,
  METHOD_NOT_ALLOWED: externalErrorStr,
  INTERNAL_SERVER_ERROR: externalErrorStr,
  SERVICE_UNAVAILABLE: externalErrorStr,
  REQUEST_TIMEOUT: externalErrorStr,
};
